import React, {useEffect} from 'react';
import AnttButton from '../../../vendors/components/Button';
import ModalContribuirComoEvento from '../../pages/DefaultPage/Evento/components/ModalContribuirComo';
import ModalCienciaEvento from '../../pages/DefaultPage/Evento/components/ModalCienciaEvento';
import ModalPesquisaSatisfacao from '../../pages/DefaultPage/Evento/components/ModalPesquisaSatisfacao';
import EventoFinalizarController from './evento-finalizar.controller';

interface Props {
  evento: any;
}

export default function EventoFinalizar({evento}: Props) {
  const controller = new EventoFinalizarController();

  useEffect(() => {
    controller.init();
  }, []);

  return (
    <>
      <AnttButton
        disabled={!evento || !evento.qtdContribuicoesPorContribuinte || evento.qtdContribuicoesPorContribuinte <= 0}
        onClick={() => controller.onShowFinalizar()}
        label="Finalizar contribuição"
      />
      <ModalContribuirComoEvento
        show={controller.showContribuirComo}
        handleFinalizar={(e: any) => controller.showFinalizar(evento, null)}
        onHide={() => controller.onHideContribuirComo()}
        controller={controller}/>
      <ModalCienciaEvento
        show={controller.showCiencia}
        handleFinalizar={(e: any) => controller.finalizarCiencia(e)}
        onHide={() => controller.onHideCiencia()}/>
      <ModalPesquisaSatisfacao show={controller.showSatisfacao}
                               onHide={() => controller.onHideSatisfacao()}
                               handleFinalizar={(e: any) => controller.finalizar(e, evento)}/>
    </>
  );
}
